import { useNavigate } from "react-router-dom";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkProcedureTable from "../../components/molecules/TkProcedureTable";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import { httpAPI_APP001, httpAPI_APP002, httpAPI_APP013 } from "./api/request";
import { IAPI_APP001_Request } from "../../type/apiType";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { navigatePath } from "./parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { TkGetCodeList } from "../../utils/TkGetCode";
import {
  DueDateList,
  HandleStatus,
  ProcedureName,
} from "../../assets/data/Constants";
import { buttonName } from "./hooks/useTools";
import { LatestProcedureInfoList } from "../../type/apiType/IAPI_APP001";
import dayjs from "dayjs";

/**
 * SCRC070101 すべての手続履歴一覧
 * @return SCRC070101 すべての手続履歴一覧
 */
const SCRC070101 = () => {
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.searchForHistory;
  const navigate = useNavigate();
  const [hisBodyList, setHisBodyList] = useState<any>([]);
  const [isShow, setIsShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const listData: any = [
    {
      keyword: "process",
      type: "selectFrom",
      label: "手続き",
      selectPropsList: TkGetCodeList(ProcedureName),
      wantToSetValue: context?.businessType,
    },
    {
      keyword: "compatibleDate",
      type: "selectFrom",
      label: "更新日",
      selectPropsList: TkGetCodeList(DueDateList),
      wantToSetValue: context?.dueDate,
    },
  ];
  let dateValid = { maxDate: new Date("2099/12/31") };

  const handleButtonClick = async (
    buttonName: string,
    data: LatestProcedureInfoList
  ) => {
    switch (buttonName) {
      case "確認":
        const fiscalYear = () => {
          if (!data?.taskCreateDate) {
            return null;
          } else {
            const dueDate = new Date(data?.taskCreateDate);
            if (dueDate.getMonth() >= 3) {
              return dueDate.getFullYear();
            } else {
              return dueDate.getFullYear() - 1;
            }
          }
        };
        const fiscalYearValue = fiscalYear();

        setBusinessState({
          searchForHistory: businessState.searchForHistory,
          common: { businessType: data.businessType },
        });
        navigate(navigatePath[data.businessType!], {
          state: {
            applyId: data.applyId,
            year: data.businessType === "JOB-79" ? fiscalYearValue : null,
          },
        });
        break;

      case "戻す":
        // 手続履歴状態更新API 実行
        try {
          const res = await httpAPI_APP002({
            contractorNo:
              state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
                ? businessState.common?.contractorNo
                : state.authInfo?.contractorNo,
            taskId: data.taskId,
            event: HandleStatus["未対応"],
          });

          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });

            navigate("/SCRC020001");
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case "取下":
        try {
          const res = await httpAPI_APP013({ applyId: data.applyId });

          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });

            navigate("/SCRC080001");
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;
    }
  };

  const handleInit = async (paramData: any) => {
    // 手続履歴一覧参照API 実行
    try {
      const res = await httpAPI_APP001({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        const listHisData = res.latestProcedureInfoList?.map((item) => ({
          important: item.importantFlg === "1",
          progress: item.latestApplyStatusName,
          date: item.dueDate,
          procedureName: item.businessTypeShortName,
          message: item.procedureTitle,
          timing: item.executionName,
          children: (
            <Box className="button">
              {buttonName(item)
                .split(",")
                .map(
                  (btnName, index) =>
                    btnName && (
                      <TkButton
                        key={index}
                        onClick={() => handleButtonClick(btnName, item)}
                      >
                        {btnName}
                      </TkButton>
                    )
                )}
            </Box>
          ),
        }));

        setHisBodyList(listHisData ?? []);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    const paramData: IAPI_APP001_Request = {
      userId: state.authInfo?.userId,
      businessType: context?.businessType,
      dueDateFrom: context?.dueDateFrom,
      dueDateTo: context?.dueDateTo,
    };
    handleInit(paramData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeDate = (e: any, i: any) => {
    if (i === 0) return;

    setStartDate("");
    setEndDate("");

    if (e === DueDateList["自分で選択"]) {
      setIsShow(true);
    } else {
      setIsShow(false);
      setBusinessState({
        searchForHistory: {
          ...context,
          dueDateFrom: "",
          dueDateTo: "",
        },
      });

      if (e === DueDateList["過去１年以上"]) {
        setStartDate("");
        let date = dayjs().subtract(1, "year").format("YYYY/MM/DD");
        setEndDate(date);
      } else if (e === DueDateList["過去１年"]) {
        let date = dayjs().subtract(1, "year").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去６ヶ月"]) {
        let date = dayjs().subtract(6, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去３ヶ月"]) {
        let date = dayjs().subtract(3, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      } else if (e === DueDateList["過去１ヶ月"]) {
        let date = dayjs().subtract(1, "month").format("YYYY/MM/DD");
        setStartDate(date);
        setEndDate("");
      }
    }
  };

  const handleSearch = (value: any) => {
    if (
      (startDate && !dayjs(startDate, "YYYY/MM/DD", true).isValid()) ||
      (endDate && !dayjs(endDate, "YYYY/MM/DD", true).isValid())
    )
      return;

    let paramData = {
      userId: state.authInfo?.userId,
      businessType: value.process,
      dueDateFrom: startDate,
      dueDateTo: endDate,
    };
    handleInit(paramData);

    setBusinessState({
      searchForHistory: { ...paramData, dueDate: value.compatibleDate },
    });
  };

  const handleChangeStartDate = (e: any) => {
    setStartDate(e.target.value);
  };

  const handleChangeEndDate = (e: any) => {
    setEndDate(e.target.value);
  };

  return (
    <Box className="SCRC070101" data-testid="SCRC070101PageForTest">
      <TkSearchForm
        listData={listData}
        onSearch={handleSearch}
        getChangeValue={handleChangeDate}
      />

      {isShow && (
        <Box className="time">
          <Box>更新日（自　〜　至）：</Box>
          <TkDatePicker
            onChange={handleChangeStartDate}
            wantToSetValue={context?.dueDateFrom}
            {...dateValid}
          />
          <Box>～</Box>
          <TkDatePicker
            onChange={handleChangeEndDate}
            wantToSetValue={context?.dueDateTo}
            {...dateValid}
          />
        </Box>
      )}

      <Box className="table">
        <TkProcedureTable
          pagin={true}
          title="最近の手続履歴"
          procedureList={hisBodyList}
          titleChangeToUpdateDay
          maxHeight={800}
        />
      </Box>

      <Box className="TkBackButton">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC070101;
